export function calculateProgress(quiz, route, answers) {
    const answeredCount = route.visitedQuestionIds.filter((questionId) => answers[questionId]).length;
    if (quiz.progress.mode === "linear") {
        return calculateLinearProgress(quiz.progress, quiz.questions.length, answeredCount, route.isComplete);
    }
    const currentQuestionId = route.currentQuestionId ?? route.visitedQuestionIds[route.visitedQuestionIds.length - 1];
    const currentQuestion = quiz.questions.find((question) => question.id === currentQuestionId);
    if (!currentQuestion?.stage)
        return route.isComplete ? 100 : 0;
    const stages = quiz.progress.stages;
    const currentStageIndex = stages.findIndex((stage) => stage.id === currentQuestion.stage);
    if (currentStageIndex < 0)
        return route.isComplete ? 100 : 0;
    const totalWeight = stages.reduce((sum, stage) => sum + stage.weight, 0);
    const completedWeight = stages.slice(0, currentStageIndex).reduce((sum, stage) => sum + stage.weight, 0);
    const stageQuestions = quiz.questions.filter((question) => question.stage === currentQuestion.stage);
    const stageVisited = route.visitedQuestionIds.filter((id) => stageQuestions.some((question) => question.id === id));
    const stageAnswered = stageVisited.filter((questionId) => answers[questionId]).length;
    const stageShare = Math.min(1, stageAnswered / Math.max(1, stageQuestions.length));
    const progress = ((completedWeight + stages[currentStageIndex].weight * stageShare) / totalWeight) * 100;
    return route.isComplete ? 100 : clampPercent(progress);
}
export function calculateLinearProgress(config, totalQuestions, answeredQuestions, isComplete = false) {
    const percent = (answeredQuestions / Math.max(1, totalQuestions)) * 100;
    if (config.mode === "linear" && config.capFinalQuestionAt99 && !isComplete && answeredQuestions >= totalQuestions) {
        return 99;
    }
    return isComplete ? 100 : clampPercent(percent);
}
function clampPercent(value) {
    return Math.max(0, Math.min(100, Math.round(value)));
}
